import * as mixpanel from 'mixpanel-figma';

export function trackEvent(eventName, properties) {
  mixpanel.track(eventName, properties);
}

export function identifyUser(userId) {
  mixpanel.identify(userId);
}
